import { render, staticRenderFns } from "./messageList.vue?vue&type=template&id=928ece50&scoped=true"
import script from "./messageList.vue?vue&type=script&lang=js"
export * from "./messageList.vue?vue&type=script&lang=js"
import style0 from "./messageList.vue?vue&type=style&index=0&id=928ece50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928ece50",
  null
  
)

export default component.exports